var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"bottom_text"},[_c('div',{staticClass:"top"},[_c('div',[_vm._v("杭州安略网络技术有限公司 版权所有")]),_c('div',[_vm._v(" 地址：浙江省杭州市滨江区西兴街道江淑路260号13656室")])]),_c('div',{staticClass:"bottom"},[_vm._v(" 网站备案：浙ICP备2025208385号 ")])])])
}]

export { render, staticRenderFns }